import { render } from "./SliderContainer.vue?vue&type=template&id=3482c4a1"
import script from "./SliderContainer.vue?vue&type=script&lang=js"
export * from "./SliderContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__